import { lazy, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import styled from 'styled-components';
import Layout from '@components/Layout';
import Loading from '@components/common/Loading';
import ProtectedRoute from '@components/admin/ProtectedRoute';

// GlobalStyles already imported in main.tsx

// Lazy-loaded pages
const Home = lazy(() => import('@pages/Home'));
const Catalog = lazy(() => import('@pages/Catalog'));
const AlbumDetails = lazy(() => import('@pages/AlbumDetails'));
const About = lazy(() => import('@pages/About'));
const Contact = lazy(() => import('@pages/Contact'));
const Licensing = lazy(() => import('@pages/Licensing'));
const Legacy = lazy(() => import('@pages/Legacy'));
const Projects = lazy(() => import('@pages/Projects'));
const GatewayToJoy = lazy(() => import('@pages/GatewayToJoy'));
const MADMagazine = lazy(() => import('@pages/MADMagazine'));
const ForbiddenElvis = lazy(() => import('@pages/ForbiddenElvis'));
const Betty = lazy(() => import('@pages/Betty'));
const NotFound = lazy(() => import('@pages/NotFound'));
const AdminLogin = lazy(() => import('@pages/admin/Login'));
const AdminTracks = lazy(() => import('@pages/admin/TracksCRM'));
const AdminAccount = lazy(() => import('@pages/admin/Account'));

const AppContainer = styled.div`
  min-height: 100vh;
  background: transparent;
`;

function App() {
  // Remove blocking catalog preload - let individual pages load catalogs as needed

  return (
    <AppContainer>
      {/* GlobalStyles added in main.tsx */}
      <Suspense fallback={<Loading fullScreen text="LOADING VINTAGE VIBES" />}>
        <Routes>
          {/* Login page - keep site chrome */}
          <Route path="/admin/login" element={<Layout><AdminLogin /></Layout>} />

          {/* All other routes - wrapped in Layout */}
          <Route path="/" element={
            <Layout>
              <Home />

            </Layout>
          } />
          <Route path="/catalog" element={
            <Layout>
              <Catalog />

            </Layout>
          } />
          <Route path="/catalog/:id" element={
            <Layout>
              <AlbumDetails />

            </Layout>
          } />
          <Route path="/legacy" element={
            <Layout>
              <Legacy />

            </Layout>
          } />
          <Route path="/projects" element={
            <Layout>
              <Projects />

            </Layout>
          } />
          <Route path="/projects/forbidden-elvis" element={
            <Layout>
              <ForbiddenElvis />

            </Layout>
          } />
          <Route path="/projects/mad-records" element={
            <Layout>
              <MADMagazine />

            </Layout>
          } />
          <Route path="/projects/folk-songs-madison-ave" element={
            <Layout>
              <MADMagazine />

            </Layout>
          } />
          <Route path="/gateway-to-joy" element={
            <Layout>
              <GatewayToJoy />

            </Layout>
          } />
          <Route path="/licensing" element={
            <Layout>
              <Licensing />

            </Layout>
          } />
          <Route path="/about" element={
            <Layout>
              <About />

            </Layout>
          } />
          <Route path="/contact" element={
            <Layout>
              <Contact />

            </Layout>
          } />
          <Route path="/betty" element={
            <Layout>
              <Betty />

            </Layout>
          } />
          <Route path="/mad-magazine" element={
            <Layout>
              <MADMagazine />

            </Layout>
          } />
          <Route path="/forbidden-elvis" element={
            <Layout>
              <ForbiddenElvis />

            </Layout>
          } />
          {/* Admin */}
          <Route
            path="/admin/tracks"
            element={
              <Layout>
                <ProtectedRoute>
                  <AdminTracks />
                </ProtectedRoute>
              </Layout>
            }
          />
          <Route
            path="/admin/account"
            element={
              <Layout>
                <ProtectedRoute>
                  <AdminAccount />
                </ProtectedRoute>
              </Layout>
            }
          />
          <Route
            path="/admin/crm"
            element={<Navigate to="/admin/tracks" replace />}
          />
          {/* Catch-all for any /admin/* routes not explicitly defined - require auth */}
          <Route
            path="/admin/*"
            element={
              <Layout>
                <ProtectedRoute>
                  <Navigate to="/admin/crm" replace />
                </ProtectedRoute>

              </Layout>
            }
          />

          {/* 404 - must be last */}
          <Route path="*" element={
            <Layout>
              <NotFound />

            </Layout>
          } />
        </Routes>
      </Suspense>
    </AppContainer>
  );
}

export default App;
